export default {
  "Normale": "Normal",
  "Haute": "High",
  "Critique": "Critical",
  "Priorité {0} — {1}": "Priority {0} — {1}",
  "Passer en mode clair": "Switch to light mode",
  "Passer en mode sombre": "Switch to dark mode",
  "Propriétaire": "Owner",
  "Administrateur": "Admin",
  "Membre": "Member",
  "Invité (lecture seule)": "Guest (read-only)",
  "Changer d'espace de travail": "Switch workspace",
  "Espace personnel": "Personal space",
  "Espaces de travail": "Workspaces",
  "Créer un espace d'équipe": "Create a team space",
  "Très faible": "Very weak",
  "Moyen": "Fair",
  "Solide": "Strong",
  "Robustesse :": "Strength:",
  " — 10 caractères minimum": " — 10 characters minimum",
  "Google (Agenda, Meet)": "Google (Calendar, Meet)",
  "Copié.": "Copied.",
  "Copier": "Copy",
  "Cliquez sur le bouton ci-dessous : Slack crée l'application": "Click the button below: Slack creates the app",
  "déjà réglée": "already configured",
  "pour vous. Choisissez votre espace Slack puis cliquez sur « Create ».": "for you. Choose your Slack workspace, then click “Create”.",
  "Créer l'application Slack en un clic": "Create the Slack app in one click",
  "Dans la page qui s'ouvre (« Basic Information »), descendez jusqu'à « App Credentials ». Copiez le": "On the page that opens (“Basic Information”), scroll down to “App Credentials”. Copy the",
  "et le": "and the",
  "(cliquez sur « Show »), puis collez-les ci-dessous.": "(click “Show”), then paste them below.",
  "Si Slack vous demande l'adresse de redirection, la voici :": "If Slack asks for the redirect URL, here it is:",
  "Ouvrez": "Open",
  "vos intégrations Notion": "your Notion integrations",
  "et cliquez sur « Nouvelle intégration ». Nom :": "and click “New integration”. Name:",
  ". Type :": ". Type:",
  "Publique": "Public",
  "Dans « Adresses de redirection », collez cette adresse :": "In “Redirect URIs”, paste this address:",
  "Remplissez les champs demandés (site web, e-mail), enregistrez, puis ouvrez l'onglet « Configuration ». Copiez l'": "Fill in the required fields (website, email), save, then open the “Configuration” tab. Copy the",
  "ID client OAuth": "OAuth client ID",
  "secret client OAuth": "OAuth client secret",
  "Ouvrez la": "Open the",
  "console Google Cloud": "Google Cloud console",
  "avec votre compte Google et créez un projet nommé": "with your Google account and create a project named",
  "Activez le service": "Enable the service",
  "(un clic sur « Activer »).": "(one click on “Enable”).",
  "Ouvrez l'": "Open the",
  "écran de consentement": "consent screen",
  ": nom de l'application": ": app name",
  ", votre e-mail, public": ", your email, audience",
  "Externe": "External",
  ". Enregistrez.": ". Save.",
  "Ouvrez les": "Open the",
  "→ « Créer des identifiants » → « ID client OAuth » → type": "→ “Create credentials” → “OAuth client ID” → type",
  "Application Web": "Web application",
  ". Dans « URI de redirection autorisés », collez :": ". In “Authorised redirect URIs”, paste:",
  "Google affiche l'": "Google shows the",
  "ID client": "Client ID",
  "code secret": "client secret",
  ": copiez-les ci-dessous. Tant que Google n'a pas validé l'application, ajoutez les e-mails des testeurs dans « Audience ».": ": copy them below. Until Google has verified the app, add your testers' emails under “Audience”.",
  "{0} est activé : chaque utilisateur peut maintenant se connecter en un clic.": "{0} is enabled: every user can now connect in one click.",
  "Activer {0}": "Enable {0}",
  "À faire une seule fois, par vous (administrateur). Ensuite, vos utilisateurs n'auront qu'un bouton à cliquer.": "To do once, by you (admin). After that, your users just click a button.",
  "Chargement…": "Loading…",
  "Déjà activé": "Already enabled",
  " (par les réglages du serveur)": " (by the server settings)",
  ". Vous pouvez remplacer les identifiants ci-dessous.": ". You can replace the credentials below.",
  "Collez l'ID client": "Paste the client ID",
  "Code secret": "Client secret",
  "Il est chiffré et n'est plus jamais affiché.": "It is encrypted and never shown again.",
  "Collez le code secret": "Paste the client secret",
  "Activer pour tous les utilisateurs": "Enable for all users",
  "Désactiver {0} pour tout le monde ?": "Disable {0} for everyone?",
  "Connecteur désactivé.": "Connector disabled.",
  "Désactiver ce connecteur": "Disable this connector",
  "Votre Copilote utilise une IA": "Your Copilot uses AI",
  "Une seule fois : votre accord avant d'utiliser les fonctions d'intelligence artificielle.": "Just once: your consent before using the artificial intelligence features.",
  "Quand vous utilisez le Coach ou une fonction IA (documents, marketing, rappels, comptes rendus…),": "When you use the Coach or an AI feature (documents, marketing, reminders, meeting notes…),",
  "votre demande et les informations utiles de votre espace": "your request and the relevant information from your workspace",
  "sont envoyées à notre fournisseur d'IA,": "are sent to our AI provider,",
  ", pour produire la réponse.": ", to produce the answer.",
  "Ces données peuvent être traitées hors de l'Union européenne. Évitez d'y mettre des informations sensibles (santé, mots de passe, numéros de carte). Vous pouvez retirer votre accord à tout moment dans Paramètres › Confidentialité.": "This data may be processed outside the European Union. Avoid including sensitive information (health, passwords, card numbers). You can withdraw your consent at any time in Settings › Privacy.",
  "En savoir plus :": "Learn more:",
  "politique de confidentialité": "privacy policy",
  "Merci ! Votre Copilote est prêt.": "Thank you! Your Copilot is ready.",
  "J'accepte": "I agree",
  "Sans accord, les fonctions d'IA restent désactivées ; le reste de l'application fonctionne normalement.": "Without consent, AI features stay off; the rest of the app works normally.",
  "Créneau": "Time slot",
  "Agenda": "Calendar",
  "Mémoire": "Memory",
  "Finances": "Finances",
  "Objectif": "Goal",
  "Devis / facture": "Quote / invoice",
  "Encaissement": "Payment",
  "Automatisation": "Automation",
  "Équipe": "Team",
  "L'action a échoué.": "The action failed.",
  "Action appliquée.": "Action applied.",
  "Ouvrir": "Open",
  "Appliquée": "Applied",
  "Ignorée": "Dismissed",
  "Modifier avant d'appliquer": "Edit before applying",
  "Valider": "Approve",
  "Modifier l'action avant validation": "Edit the action before approving",
  "Paramètres envoyés au serveur (revalidés avant exécution).": "Parameters sent to the server (re-validated before execution).",
  "Paramètres de l'action": "Action parameters",
  "JSON invalide.": "Invalid JSON.",
  "Valider avec ces paramètres": "Approve with these parameters",
  "Actions proposées — rien n'est fait sans votre validation": "Proposed actions — nothing happens without your approval",
  "{0} action(s) en échec.": "{0} action(s) failed.",
  "{0} actions appliquées.": "{0} actions applied.",
  "Tout valider (": "Approve all (",
  "Aucune donnée sur la période.": "No data for this period.",
  "Masquer le tableau": "Hide table",
  "Afficher les données": "Show data",
  "Période": "Period",
  "Accueil GBC Coach IA": "GBC Coach IA home",
  "GBC Coach IA · une application NeoTechRams": "GBC Coach IA · a NeoTechRams app",
  "Votre entreprise avance.": "Your business moves forward.",
  "Votre IA vous aide à garder une longueur d'avance.": "Your AI helps you stay one step ahead.",
  "Coach IA · Planification · Finances · Documents": "AI Coach · Planning · Finances · Documents",
  "Bientôt": "Soon",
  "Menu utilisateur": "User menu",
  "· Formule": "· Plan",
  "Profil et paramètres": "Profile and settings",
  "Abonnement": "Subscription",
  "Mode clair": "Light mode",
  "Mode sombre": "Dark mode",
  "Aide": "Help",
  "Se déconnecter": "Sign out",
  "Rechercher…": "Search…",
  "Navigation principale": "Main navigation",
  "Aller au contenu": "Skip to content",
  "Rechercher": "Search",
  "Navigation mobile": "Mobile navigation",
  "Plus de sections": "More sections",
  "Plus": "More",
  "Toutes les sections": "All sections",
  "Fermer le menu": "Close menu",
  "Conflit avec : {0}": "Conflicts with: {0}",
  "Une fois": "Once",
  "Chaque semaine": "Every week",
  "Chaque mois": "Every month",
  "Préférences enregistrées.": "Preferences saved.",
  "Accès au micro refusé. Autorisez-le dans les réglages du navigateur.": "Microphone access denied. Allow it in your browser settings.",
  "Aucune voix détectée.": "No voice detected.",
  "La reconnaissance vocale du navigateur nécessite une connexion.": "The browser's speech recognition needs a connection.",
  "La dictée n'est pas prise en charge par ce navigateur.": "Dictation is not supported by this browser.",
  "La dictée s'est interrompue.": "Dictation stopped.",
  "Statistiques, formules et modules de la plateforme.": "Platform statistics, plans and modules.",
  "Impossible de charger votre compte.": "Unable to load your account.",
  "Réessayer": "Try again",
  "à l'instant": "just now",
  "Connexion impossible. Vérifiez votre réseau.": "Unable to connect. Check your network.",
  "Une erreur est survenue.": "An error occurred.",
  "La requête a échoué.": "The request failed.",
  "Vue d'ensemble": "Overview",
  "Votre journée et votre activité en un coup d'œil.": "Your day and your business at a glance.",
  "Votre Copilote conversationnel.": "Your conversational Copilot.",
  "Planification": "Planning",
  "Calendrier, disponibilités et planification intelligente.": "Calendar, availability and smart planning.",
  "Tâches et projets": "Tasks and projects",
  "Tâches, projets, priorités et dépendances.": "Tasks, projects, priorities and dependencies.",
  "Transactions, trésorerie et prévisionnel.": "Transactions, cash flow and forecasts.",
  "Devis, factures, propositions et modèles.": "Quotes, invoices, proposals and templates.",
  "Rappels": "Reminders",
  "« Rappelle-moi de… » : à l'heure dite, sur tous vos appareils.": "“Remind me to…”: right on time, on all your devices.",
  "Studio marketing": "Marketing studio",
  "Posts, publicités, client idéal, plan marketing : prêts en un clic.": "Posts, ads, ideal customer, marketing plan: ready in one click.",
  "Réunions": "Meetings",
  "Comptes rendus, décisions et actions à partir de vos notes ou de votre voix.": "Minutes, decisions and actions from your notes or your voice.",
  "Fichiers et connaissances": "Files and knowledge",
  "Stockage sécurisé et base de connaissances.": "Secure storage and knowledge base.",
  "Automatisations": "Automations",
  "Workflows avec déclencheurs, conditions et validations.": "Workflows with triggers, conditions and approvals.",
  "Objectifs et performances": "Goals and performance",
  "Objectifs, jalons et progression transparente.": "Goals, milestones and transparent progress.",
  "Espace partagé, rôles et permissions.": "Shared workspace, roles and permissions.",
  "Intégrations": "Integrations",
  "Rappels, alertes et activité.": "Reminders, alerts and activity.",
  "Paramètres": "Settings",
  "Profil, interface, IA, mémoire et confidentialité.": "Profile, interface, AI, memory and privacy.",
  "Téléchargement impossible.": "Download failed.",
  "En retard · {0}": "Overdue · {0}",
  "Découverte": "Discovery",
  "Essentiel": "Essential",
  "Invitation invalide ou expirée": "Invalid or expired invitation",
  "Demandez une nouvelle invitation à la personne qui vous a invité.": "Ask the person who invited you for a new invitation.",
  "Ouvrir l'application": "Open the app",
  "Rejoindre «": "Join “",
  "Un membre": "A member",
  "vous invite en tant que": "invites you as",
  ". Invitation adressée à": ". Invitation sent to",
  "Rejoindre l'espace": "Join the workspace",
  "Connecté en tant que": "Signed in as",
  ". Votre espace personnel reste privé.": ". Your personal space stays private.",
  "Se connecter pour rejoindre": "Sign in to join",
  "Créer un compte": "Create an account",
  "Six modes spécialisés, réponses en temps réel, actions proposées puis validées par vous.": "Six specialised modes, real-time answers, actions proposed then approved by you.",
  "Décrivez un objectif : le coach le transforme en mission (tâches, échéances, jalons).": "Describe a goal: the coach turns it into a mission (tasks, deadlines, milestones).",
  "Tâches, projets, agenda, « Ma journée en un clic » et détection de surcharge.": "Tasks, projects, calendar, “My day in one click” and overload detection.",
  "Trésorerie": "Cash flow",
  "Suivi, prévisionnel 30/60/90 jours en trois scénarios, simulateur de décisions.": "Tracking, 30/60/90-day forecast in three scenarios, decision simulator.",
  "Devis, factures, propositions : générés, vérifiés, exportés en PDF.": "Quotes, invoices, proposals: generated, checked, exported to PDF.",
  "Factures à relancer, projets bloqués, objectifs en retard : détectés et expliqués.": "Invoices to chase, blocked projects, goals behind schedule: detected and explained.",
  "Déclencheurs, conditions, actions — avec validation humaine et journal.": "Triggers, conditions, actions — with human approval and a log.",
  "Copilote vocal": "Voice Copilot",
  "Parlez-lui mains libres ; enregistrez vos réunions, il les transcrit.": "Talk to it hands-free; record your meetings, it transcribes them.",
  "Rappels intelligents": "Smart reminders",
  "« Rappelle-moi de relancer Paul jeudi » : c'est noté, à l'heure dite.": "“Remind me to follow up with Paul on Thursday”: noted, right on time.",
  "Posts, publicités, client idéal, plan 90 jours : prêts en un clic.": "Posts, ads, ideal customer, 90-day plan: ready in one click.",
  "Mémoire contrôlable": "Memory you control",
  "Le coach retient ce que vous choisissez. Vous voyez et effacez tout.": "The coach remembers what you choose. You can see and erase everything.",
  "Confidentialité": "Privacy",
  "Données isolées, export et suppression en un clic, RGPD dès la conception.": "Isolated data, one-click export and deletion, GDPR by design.",
  "Connexion": "Sign in",
  "Commencer": "Get started",
  "Copilote IA pour entrepreneurs": "AI Copilot for entrepreneurs",
  "Votre IA garde une longueur d'avance.": "Your AI keeps you one step ahead.",
  "Coach, planning, trésorerie, documents, réunions et automatisations dans une seule app. L'IA propose, vous validez.": "Coach, planning, cash flow, documents, meetings and automations in one app. The AI proposes, you approve.",
  "Créer mon Copilote": "Create my Copilot",
  "J'ai déjà un compte": "I already have an account",
  "Briefing du jour": "Today's briefing",
  "3 priorités · 1 facture à relancer": "3 priorities · 1 invoice to chase",
  "Trésorerie à 30 j": "30-day cash flow",
  "« Prépare le compte rendu de ma réunion avec Martin »": "“Prepare the minutes of my meeting with Martin”",
  "Illustration de l'interface": "Interface illustration",
  "Tout votre business, une seule app.": "Your whole business, one app.",
  "Vous gardez la main": "You stay in control",
  "Toute action proposée par l'IA attend votre validation.": "Every action proposed by the AI waits for your approval.",
  "Aucune donnée inventée": "No made-up data",
  "Le coach distingue faits, hypothèses et estimations, et cite ses sources.": "The coach separates facts, assumptions and estimates, and cites its sources.",
  "Vos données vous appartiennent": "Your data belongs to you",
  "Export complet, suppression, mémoire visible et effaçable.": "Full export, deletion, visible and erasable memory.",
  "Un prix pour chaque budget": "A price for every budget",
  "Commencez gratuitement. Passez à la formule supérieure quand votre activité grandit. Sans engagement.": "Start for free. Upgrade when your business grows. No commitment.",
  "Coach IA inclus chaque jour": "AI Coach included every day",
  "Tâches, agenda, finances": "Tasks, calendar, finances",
  "Devis et factures": "Quotes and invoices",
  "Rappels et conseil du jour": "Reminders and tip of the day",
  "Le plus choisi": "Most popular",
  "Commencer gratuitement": "Start for free",
  "Conditions": "Terms",
} as Record<string, string>;
